import React from "react";
import "../assets/Css/services.css";
import "../index.css"
import s1 from "../assets/images/services1.png";
import website from "../assets/images/website.svg";
import websitedesign from "../assets/images/websitedesign.svg";
import video from "../assets/images/video.svg";
import eccomerce from "../assets/images/eccomerce.svg";
import seo from "../assets/images/seo.svg";
import ServiceData from "../Data/ServiceData.js";
export default function OurServices() {
  return (
    <>
      <section id="services" className="services-wraaper  page-width">
        <div className="services-top">
          <div className="services-cont1">
            <h3>We are Not agency We are Brand that we called...</h3>
          </div>
          <div className="services-cont2">
            <span>
              <p>
              we proudly say we are XeBrand, where excellence meets innovation in every endeavor we undertake.
              </p>
            </span>
            <span>
              <h3>Our services</h3>
            </span>
          </div>
        </div>
        <div className="services-container">
          <div className="container-wrappper">
            {ServiceData.map((check, id) => {
return<>
 <a key={id} href="#">
              <div className="card">
                <div className="card-img">
               
                  <img src={check.images}alt="" />
                </div>
                <div className="card-content">
                  <div className="content-titile">
                    <h2>{check.name}</h2>
                  </div>
                  <div className="content-caption">
                    <p>{check.content}</p>
                  </div>
                </div>
              </div>
            </a></>
            })} 
           
          </div>
        </div>
      </section>
    </>
  );
}
